import React from 'react';
import { Box, Tabs } from '@mui/material';
import { useLocation, useParams } from 'react-router-dom';
import { useStyles } from './styles/styles';
import CustomTab from './components/CustomTab';
import { NAV_TABS } from './constansts';
import { isStakeholder } from '../../../../utils/share';

const NavigationTab = () => {
  const { id } = useParams();
  const location = useLocation();
  const classes = useStyles();
  const visibleTabs = isStakeholder() ? NAV_TABS.filter((tab) => tab.label !== 'Board') : NAV_TABS;
  const acitveTab = visibleTabs.findIndex((tab) => location?.pathname.includes(tab.path));
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
      <Tabs className={classes.rootTab} value={acitveTab}>
        {visibleTabs.map((tab) => (
          <CustomTab key={tab.label} label={tab.label} to={`${tab.path}/${id}`} />
        ))}
      </Tabs>
    </Box>
  );
};

export default NavigationTab;
